class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.variantId, event.target.dataset.handle);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '#cart-items',
      },
      {
        id: 'cart-live-region-text',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '#cart-live-region-text'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '#cart-price__total_price',
      },
      /**
       * developer: kanehori
       * 合計値部分更新のため追加
       */
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-update',
      },
      /**
       * developer: kanehori
       * 合計値部分更新のため追加
       */
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-total-point',
      },
      /**
       * developer: kanehori
       * 合計値部分更新のため追加
       */
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-button-update',
      },
      /**
       * developer: kanehori
       * 合計値部分更新のため追加
       */
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.wl-line_item_point',
      }
    ];
  }

  /**
   * TODO: 商品の最大購入数設定
   * developer: kanehori
   * 下記の引数追加
   * variantId = false, limitItemQuantity = 4, limitVariantQuantity = 2
   */
  async updateQuantity(line, quantity, name, variantId = false, targetHandle = false, limitItemQuantity = 4, limitVariantQuantity = 2) {
    /**
     * TODO: 商品の最大購入数設定
     * developer: kanehori
     */
    if(variantId !== false && targetHandle !== false) {
      const quantityLimit = await ISSEYMIYAKE['QuantityLimit'].init(quantity, variantId, limitItemQuantity, limitVariantQuantity, targetHandle)
      if(quantityLimit?.error) {
        document.querySelector('#Quantity-' + line).value = quantityLimit.value
        const error = document.createElement('p')
        error.setAttribute('class', 'error-message')
        error.innerHTML = quantityLimit?.text
        document.querySelector('#cart-errors').innerHTML = ''
        if(document.querySelector('#cart-errors').childNodes.length == 0) {
          document.querySelector('#cart-errors').append(error)
        }
        
        if(!document.querySelector('#Quantity-' + line).closest('div.cart-item__data').classList.contains('quantity-error')) {
          document.querySelector('#Quantity-' + line).closest('div.cart-item__data').classList.add('quantity-error')
          
        }
        return false
      }
    }
    
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (parsedState.item_count !== 0) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            /**
             * developer: kanehori
             * 合計値部分のdata属性セットと表示
             */
            this.updatePointAndPrice(parsedState)
          } else {
            this.cartEmptySectionUpdate()
          }
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        
        

        this.disableLoading();
      }).catch((e) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
        console.log(e);
      });
  }
  cartEmptySectionUpdate() {
    const target = document.querySelector('#main-cart-items')
    fetch(location.href + '?sections=' + target.dataset.id)
      .then(res => res.json())
      .then(res => {
        document.querySelector('#main-cart-items').innerHTML = this.getSectionInnerHTML(res[target.dataset.id], '.section__inner')
      })
      .catch(error => console.error(error))
  }
  /**
   * developer: kanehori
   * 合計値部分のdata属性セットと表示関数 start
   * 103行目付近で使用
   * @param {arary} parsedState This array is the cart infomation.
   */
  updatePointAndPrice(parsedState) {
    if (parsedState.item_count === 0) return true
    const totalPrice = document.querySelector('.js-totalprice')
    const point = document.querySelector('.js-usepoint-text')
    const itemPointList = document.querySelectorAll('.cart-item__databody__price_text')

    // 合計値の部分のdata属性にセット
    totalPrice.dataset.value = (parsedState.total_price / 100)

    // 合計値の部分にトータルとポイントを引いた金額をセット
    if(Number(point.dataset.value) > 0) {
      totalPrice.dataset.comutedValue = (parsedState.total_price / 100) - Number(point.dataset.value)
    }

    ISSEYMIYAKE.Cart.init()
    // 合計値の金額を合計値のinnerにセット
    totalPrice.innerHTML = ((parsedState.total_price / 100) - Number(point.dataset.value)).toLocaleString() + ' 円' 
  }
  // * 合計値部分のdata属性セットと表示関数 end

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
    const cartButton = document.querySelector('.cart__checkout-button');
    cartButton.disabled = true;

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
    const cartButton = document.querySelector('.cart__checkout-button');
    cartButton.disabled = false;
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
